import React from 'react';
import { RuleEngineState } from './models/RuleEngineState';
import { formatRuleAsText } from './utils/ruleToText';

export interface RuleEngineViewerProps {
  state?: RuleEngineState;
  segments?: Array<{ internalId: number; name: string; rules?: RuleEngineState }>;
  checkoutId?: number;
}

export const RuleEngineV2Viewer: React.FC<RuleEngineViewerProps> = ({ state, segments, checkoutId }) => {
  const renderRuleEngineState = (ruleState: RuleEngineState) => {
    return (
      <div className="rule-engine-v2-viewer">
        {ruleState?.ruleGroups?.length > 0 && (
          <div className="rule-engine-v2-viewer__rule-group-list">
            {ruleState.ruleGroups.map((ruleGroup, groupIndex) => {
              return (
                <React.Fragment key={ruleGroup.internalId}>
                  <div className="rule-engine-v2-viewer__rule-group">
                    <div className="rule-engine-v2-viewer__rules">
                      {ruleGroup.rules?.length > 0 && (
                        <div className="rule-engine-v2-viewer__rules-list">
                          {ruleGroup.rules?.map((rule, ruleIndex) => {
                            return (
                              <React.Fragment key={rule.internalId}>
                                <div className="rule-engine-v2-viewer__rules-list__item">
                                  <div className="rule-engine-v2-viewer__rules-list__item__text">
                                    {formatRuleAsText(rule) || 'Incomplete rule'}
                                  </div>
                                </div>
                                {ruleIndex < ruleGroup.rules.length - 1 && (
                                  <div className="rule-engine-v2-viewer__connector">
                                    {ruleGroup.matchAllRules ? 'and' : 'or'}
                                  </div>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  {groupIndex < ruleState.ruleGroups.length - 1 && (
                    <div className="rule-engine-v2-viewer__connector rule-engine-v2-viewer__connector--group">
                      {ruleState.matchAllRuleGroups ? 'and' : 'or'}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  if (segments && segments.length > 0) {
    return (
      <>
        {segments.map((segment) => (
          <React.Fragment key={`${checkoutId}-${segment.internalId}`}>
            <div className="segment">
              <div className="segment-header header-expanded">
                <span className="rule-engine-v2-viewer__segment-name">{segment.name}</span>
              </div>
              <div className="segment-content seg-expanded">
                {renderRuleEngineState(
                  segment?.rules
                    ? segment.rules
                    : {
                        matchAllRuleGroups: true,
                        ruleGroups: [],
                      },
                )}
              </div>
            </div>
            {segment.internalId > Math.min(...segments.map((x) => x.internalId)) && (
              <div className="segment-splitter">OR</div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }

  if (state) {
    return renderRuleEngineState(state);
  }

  return null;
};
